import React from "react";

import axios from "axios";

import { ChatRequestPayloadContext } from "../contexts/ChatRequestPayloadContext";

import { ProductListContext } from "../contexts/ProductListContext";

import { IconButton, Tooltip } from "@mui/material";

import RotateLeftIcon from "@mui/icons-material/RotateLeft";

import { getData } from "../utils/app-service";

import "./customTable.css";

const ActionProvider = ({

  createChatBotMessage,

  setState,

  children,

  ...rest

}) => {

  const { payload, updatePayload } = React.useContext(

    ChatRequestPayloadContext

  );

  const { setClearFilters } = React.useContext(ProductListContext);

 

  const { updateProducts, setLoading } = React.useContext(ProductListContext);

 

  async function handleBotReply(message) {

    const emptyReply = createChatBotMessage(null);

    setState((prev) => ({

      ...prev,

      messages: [...prev.messages, emptyReply],

    }));

 

    // Send a GET request to the API

    try {

      // Send a GET request to the API

      const response = await getData(

        "https://ai-retail-genai-kdp-api.azurewebsites.net/copilot",

        {

          query: `${message}`,

          user_id: "uuu",

        }

      );

 

      console.log("response", response);

      if (response?.data) {

        console.log(response);

        const botMessage = createChatBotMessage(response?.data?.message);

        console.log("boatmsg", botMessage);

        let products = response?.data?.products || [];

        console.log("products", products);

        updatePayload(response?.data?.conversation_object);

        const suggestedProductIds =

          response?.data?.productId && response?.data?.productId.length > 0

            ? response?.data?.productId

            : [];

 

        if (products.length > 0) {

          setLoading(true);

 

          const suggestedProducts = products.map((product) => {

            product["suggested"] =

              suggestedProductIds.indexOf(product.productId) > -1;

            return product;

          });

 

          products = suggestedProducts.sort((a, b) => {

            if (a.suggested && !b.suggested) {

              return -1;

            } else if (!a.suggested && b.suggested) {

              return 1;

            } else {

              return 0;

            }

          });

 

          setTimeout(() => {

            setLoading(false);

          }, 1000);

        }

        console.log("products", products);

        updateProducts(products);

 

        setState((prev) => {

          const prevMsgs = [...prev.messages];

          const emptyIndex = prevMsgs.findIndex(

            (item) => item.id === emptyReply.id

          );

          prevMsgs.splice(emptyIndex, 1, botMessage);

          return {

            ...prev,

            messages: prevMsgs,

          };

        });

      } else {

        console.log("Got empty data");

        throw new Error("Got empty data from server.");

      }

    } catch (error) {

      setLoading(false);

      console.error("Error while getting chat reply:", "Error:", error);

      const botMessage = createChatBotMessage("Sorry! Failed to get response.");

      setState((prev) => {

        const prevMsgs = [...prev.messages];

        const emptyIndex = prevMsgs.findIndex(

          (item) => item.id === emptyReply.id

        );

        prevMsgs.splice(emptyIndex, 1, botMessage);

        return {

          ...prev,

          messages: prevMsgs,

        };

      });

    }

  }

 

  async function handleRest() {

    updatePayload && updatePayload([]);

    setClearFilters((prev) => !prev);

    const initialMsg = createChatBotMessage("Hi there !");

    setState((prev) => ({

      ...prev,

      messages: [initialMsg],

    }));
 await getData(

    "https://ai-retail-genai-kdp-api.azurewebsites.net/api/resetuser"
    )
  }

 

  return (

    <div>

      {React.Children.map(children, (child) => {

        return React.cloneElement(child, {

          actions: {

            handleBotReply,

            handleRest,

          },

        });

      })}

      <Tooltip title="Reset conversation">

        <IconButton

          sx={{

            position: "fixed",

            right: "4px",

            bottom: "6px",

          }}

          onClick={(e) => handleRest()}

        >

          <RotateLeftIcon fontSize="medium" />

        </IconButton>

      </Tooltip>

    </div>

  );

};

 

export default ActionProvider;

 